import {Box, Stack, Typography} from "@mui/material";
import * as React from "react";
import MenuItems from './MenuItems';
import { useLocation } from "react-router-dom";
import {useEffect} from "react";

const MenuNotConnected = () => {
    let location = useLocation();
    console.log('isLoading','MenuNotConnected');
    useEffect(() => {
        const anchorEl = document.getElementById(location.hash.substring(1));
        if (anchorEl) {
            window.scrollTo({
                top: anchorEl.offsetTop - process.env.REACT_APP_HEADER_HEIGHT,
                behavior: 'smooth',
            });

        }
        console.log('location',location)
    }, [location]);


    return (
        <Stack direction={'row'}>
            <MenuItems imageSrc ={`/assets/icon/home.png`} label={'Accueil'} link={''}/>
            <MenuItems imageSrc ={`/assets/icon/présentation.png`} label={'Présentation'} link={'#service'}/>
            <MenuItems imageSrc ={`/assets/icon/Fonctionnalité.png`} label={'Fonctionnalités'} link={'#text_fonctionality'}/>
            <MenuItems imageSrc ={`/assets/icon/Abonnement_(2).png`} label={'Abonnement'} link={'#subscription'}/>
            <MenuItems imageSrc ={`/assets/icon/qui_sommes_nous.png`} label={'Qui sommes-nous'} link={'#who'}/>
        </Stack>
    )
}

export default MenuNotConnected;
